import React, { useEffect, useRef, useState } from 'react';
import VideoPlayer from '@/components/VideoPlayer';
import MainBackupVideoPlayer from '../MainBackupVideoPlayer';
import './index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { request } from '@/fetch/core';

const FrontVideoPlayer = ({
  mainUrl,
  slaveUrl,
  vehicleName,
  warning,
  takeOverBySelf,
  camera360Front,
  gearPosition,
  userName,
  shouldLoad = true,
  onVideoReady,
  onVideoTimeout,
}: {
  mainUrl: string;
  slaveUrl: string;
  vehicleName: string;
  warning: boolean;
  takeOverBySelf: boolean;
  camera360Front: string;
  gearPosition: string;
  userName: string;
  shouldLoad?: boolean;
  onVideoReady?: () => void;
  onVideoTimeout?: () => void;
}) => {
  const [show360Front, setShow360Front] = useState(false);
  const [camera360Location, setCamera360Location] = useState<
    'upper-right-corner' | 'main'
  >('upper-right-corner');
  const [camera360BitRate, setCamera360BitRate] = useState(0);
  const LC_BUTTON_L2 = useSelector(
    (state: RootState) => state?.controlBtn?.LC_BUTTON_L2
  );

  const l2ClickCountRef = useRef(0);
  const l2ClickTimerRef = useRef<any>(null);
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (!LC_BUTTON_L2) {
      return;
    }

    l2ClickCountRef.current += 1;

    if (l2ClickTimerRef.current) {
      clearTimeout(l2ClickTimerRef.current);
    }

    if (l2ClickCountRef.current === 1) {
      l2ClickTimerRef.current = setTimeout(() => {
        if (show360Front) {
          setShow360Front(false);
          setCamera360Location('upper-right-corner');
        } else {
          setShow360Front(true);
        }
        l2ClickCountRef.current = 0;
      }, 1000);
    } else if (l2ClickCountRef.current >= 2) {
      if (show360Front) {
        setCamera360Location((prevLocation) =>
          prevLocation === 'upper-right-corner' ? 'main' : 'upper-right-corner'
        );
      }
      l2ClickCountRef.current = 0;
    }
  }, [LC_BUTTON_L2, show360Front]);

  useEffect(() => {
    return () => {
      if (l2ClickTimerRef.current) {
        clearTimeout(l2ClickTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      setShow360Front(false);
      setCamera360Location('upper-right-corner');
    }
  }, [gearPosition]);
  useEffect(() => {
    setShow360Front(false);
    setCamera360Location('upper-right-corner');
  }, [takeOverBySelf]);

  useEffect(() => {
    if (show360Front && camera360Location === 'upper-right-corner') {
      changeWindowSize(1);
      return;
    }
    if (show360Front && camera360Location === 'main') {
      changeWindowSize(1);
      return;
    }
    if (!show360Front && camera360BitRate > 0) {
      changeWindowSize(1);
      return;
    }
  }, [show360Front, camera360Location]);

  // 默认裁切360相机画面，切换到主窗口或者关闭360相机时恢复原始画面
  const changeWindowSize = (isCrop: 0 | 1) => {
    const requestOptions: RequestOptions = {
      method: 'POST',
      path: '/monitor/web/video/changeWindowSize',
      body: {
        vehicleName: vehicleName,
        isCrop: isCrop,
        source: 'REMOTE_JOYSTICK',
      },
    };
    request(requestOptions);
  };

  return (
    <div className="front-video-player-traffic-light-video">
      {show360Front && (
        <div
          className={`${
            camera360Location === 'main' ? 'main' : 'upper-right-corner'
          }`}
        >
          {camera360Front ? (
            <>
              <VideoPlayer
                key={'camera360Front'}
                videoUrl={camera360Front}
                vehicleName={vehicleName}
                videoId={6}
                showVideoId={6}
                needSendData={true}
                getVideoBitRateInfo={(v) => {
                  setCamera360BitRate(v);
                }}
              />

              <div
                className="on-demand-stream-tip"
                style={{ display: camera360BitRate > 0 ? 'none' : '' }}
              >
                按需拉流
              </div>
            </>
          ) : (
            <div className="no-camera-tip">
              <img
                src={require('@/assets/images/mutilVehicle/video-failed.png')}
                alt="Video failed"
              />
              <i>无法获取视频</i>
            </div>
          )}
        </div>
      )}
      <div
        className={`${
          camera360Location === 'main' ? 'upper-right-corner' : 'main'
        }`}
      >
        <MainBackupVideoPlayer
          key={'front'}
          mainUrl={mainUrl}
          slaveUrl={slaveUrl}
          direction="前"
          videoId={0}
          slaveVideoId={500}
          vehicleName={vehicleName}
          warning={warning}
          takeOverBySelf={takeOverBySelf}
          needSendData={true}
          userName={userName}
          shouldLoad={shouldLoad}
          onVideoReady={onVideoReady}
          onVideoTimeout={onVideoTimeout}
        />
      </div>
    </div>
  );
};

export default React.memo(FrontVideoPlayer);
